const Step6 = ({ edit, userDetail, setFormData }) => {
  const filterReposo = userDetail?.cardiovascular_system?.discipline.find(
    (e) => e.discipline_id == 4
  );
  const filterRecuperation = userDetail?.cardiovascular_system?.discipline.find(
    (e) => e.discipline_id == 18
  );

  const reposo = [
    {
      name: "FC. PROM",
      value: filterReposo?.hr_med || 0,
    },
    {
      name: "FC. MAX",
      value: filterReposo?.hr_max || 0,
    },
    {
      name: "VFC",
      value: filterReposo?.get_rmssd || 0,
    },
  ];
  const recuperation = [
    {
      name: "FC. MAX",
      value: filterRecuperation?.hr_max || 0,
    },
    {
      name: "FC. en 5 minutos",
      value: filterRecuperation?.fc_5min || 0,
    },
    {
      name: "FC. en 7 minutos",
      value: filterRecuperation?.fc_7min || 0,
    },
    {
      name: "FC. en 10 minutos",
      value: filterRecuperation?.fc_10min || 0,
    },
  ];

  return (
    <div className="d-flex flex-column col-3 px-2 h-100 w-100">
      <div className="d-flex justify-content-start">
        <span className="label-step">
          <strong>6. Sistema Cardiopulmonar</strong>
        </span>
      </div>

      <div className="pt-2 d-flex flex-column gap-2" style={{ height: "94%" }}>
        {/* Parte 1: Objetivos */}
        <div className="step3-card py-1 px-4 flex-grow-1 d-flex flex-column justify-content-center align-items-center">
          <span className="mb-2 label-step">
            <strong>Prueba en reposo</strong>
          </span>

          {filterReposo ? (
            <>
              {reposo.map((item, idx) => (
                <div
                  key={idx}
                  className="input_info_athlete gap-2 col-12 d-flex align-items-center justify-content-between"
                >
                  <span className="col-6" style={{ textAlign: "right" }}>
                    {item.name}
                  </span>
                  <input
                    defaultValue={item.value}
                    type="number"
                    className="col-6 input-recuperation-input input_info_athlete_input"
                    readOnly={true}
                  />
                </div>
              ))}
            </>
          ) : (
            <div>
              <span className="label-step">No hay datos</span>
            </div>
          )}
        </div>

        {/* Parte 2: Prueba de recuperación */}
        <div className="step3-card py-1 px-4 flex-grow-1 d-flex flex-column justify-content-center align-items-center">
          <span className="mb-2 label-step">
            <strong>Prueba de recuperación</strong>
          </span>
          {filterRecuperation ? (
            <>
              {recuperation.map((item, idx) => (
                <div
                  key={idx}
                  className="input_info_athlete gap-2 col-12 d-flex align-items-center justify-content-between"
                >
                  <span className="col-6" style={{ textAlign: "right" }}>
                    {item.name}
                  </span>
                  <input
                    defaultValue={item.value}
                    type="number"
                    className="col-6 input-recuperation-input input_info_athlete_input"
                    readOnly={true}
                  />
                </div>
              ))}
            </>
          ) : (
            <div>
              <span className="label-step">No hay datos</span>
            </div>
          )}
        </div>
        {/* Parte 3: tension */}
        <div className="d-flex justify-content-center gap-3 align-items-center flex-grow-1 ">
          <div className="w-70">
            <label className="input_info_athlete_input">SAT (%)</label>
            <input
              defaultValue={
                userDetail?.cardiovascular_system?.h_blood_saturation ||
                undefined
              }
              placeholder="Ingresar %"
              type="number"
              className="input_info_athlete_input p-2 w-100"
              style={{
                border: "1px solid #b6c1ce",
                borderRadius: "20px",
                textAlign: "center",
              }}
              readOnly={!edit}
              onChange={(e) => {
                setFormData((prev) => ({
                  ...prev,
                  cardiovascular_system: {
                    ...prev.cardiovascular_system,
                    ["h_blood_saturation"]: Number(e.target.value),
                  },
                }));
              }}
            />
          </div>
          <div className="w-70">
            <label className="input_info_athlete_input">Tensión (mg)</label>
            <div
              className="d-flex gap-2 align-items-center input_info_athlete_input"
              style={{
                border: "1px solid #b6c1ce",
                borderRadius: "20px",
                textAlign: "center",
              }}
            >
              <input
                defaultValue={
                  userDetail?.cardiovascular_system?.h_blood_pressure_s ||
                  undefined
                }
                placeholder="Sistólica"
                type="number"
                onChange={(e) => {
                  setFormData((prev) => ({
                    ...prev,
                    cardiovascular_system: {
                      ...prev.cardiovascular_system,
                      ["h_blood_pressure_s"]: Number(e.target.value),
                    },
                  }));
                }}
                className=" p-2 w-100"
                style={{
                  border: "none",
                  borderRadius: "20px",
                  textAlign: "center",
                }}
                readOnly={!edit}
              />
              <span className="input_info_athlete_input">/</span>
              <input
                defaultValue={
                  userDetail?.cardiovascular_system?.h_blood_pressure_d ||
                  undefined
                }
                placeholder="Diastólica"
                type="number"
                className=" p-2 w-100"
                style={{
                  border: "none",
                  borderRadius: "20px",
                  textAlign: "center",
                }}
                readOnly={!edit}
                onChange={(e) => {
                  setFormData((prev) => ({
                    ...prev,
                    cardiovascular_system: {
                      ...prev.cardiovascular_system,
                      ["h_blood_pressure_d"]: Number(e.target.value),
                    },
                  }));
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step6;
